<!--
 * @Author: 月魂
 * @Date: 2021-02-02 17:20:29
 * @LastEditTime: 2022-01-20 15:06:39
 * @LastEditors: 月魂
 * @Description: 
 * @FilePath: \bingmayong-ukraine-mobile\src\components\Header.vue
-->
<template>
  <div class="header">
    <div class="trigger" v-if="!visible" @click="visible = true">
      <img src="http://image.wearetogether.com.cn/menu-ukraine.png" />
    </div>
    <van-popup
      v-else
      v-model="visible"
      @click="visible = false"
      position="bottom"
    >
      <div class="menu-list">
        <ul>
          <li
            v-show="title !== 'preface'"
            class="return"
            @click.stop="() => {}"
          >
            <img
              src="http://image.wearetogether.com.cn/menu-preface.png"
              @click="() => this.$router.push('/preface')"
            />
          </li>
          <li
            v-for="item in menu"
            :key="item.id"
            class="menu-item"
            @click.stop="handleClick(item)"
          >
            <img
              :src="
                'http://cdn.topartsintermational.com/menu-ser-' +
                item.name +
                '.png'
              "
            />
            <img
              v-if="title === item.name"
              class="menu-text"
              :src="
                'http://image.wearetogether.com.cn/menu-select-' +
                item.menu +
                '.png'
              "
            />
            <img
              v-else
              class="menu-text"
              :src="
                'http://image.wearetogether.com.cn/menu-' +
                item.menu +
                '.png'
              "
            />
          </li>
          <li class="return" @click.stop="() => {}">
            <img
              src="http://image.wearetogether.com.cn/menu-return.png"
              @click.stop="visible = false"
            />
          </li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    title: String,
  },
  data () {
    return {
      visible: false,
      menu: [
        {
          id: 1,
          name: 'history',
          menu: 'history',
          link: '/history',
        },
        {
          id: 2,
          name: 'warriors',
          menu: 'warriors-n',
          link: '/warriors',
        },
        {
          id: 3,
          name: 'ancient',
          menu: 'ancient',
          link: '/ancient',
        },
        {
          id: 4,
          name: 'culture',
          menu: 'culture',
          link: '/culture',
        },
        {
          id: 5,
          name: 'visit',
          menu: 'visit',
          link: '/visit',
        },
        {
          id: 6,
          name: 'creation',
          menu: 'creation',
          link: '/creation',
        },
        {
          id: 7,
          name: 'game',
          menu: 'game',
          link: '/game',
        },
      ],
    }
  },
  methods: {
    handleClick (params) {
      if (this.$route.path === params.link) return
      this.$router.push(params.link)
    },
  },
}
</script>

<style scoped lang="less">
ul li {
  list-style: none;
  padding: 0;
  margin: 0;
}
.trigger {
  width: 100px;
  position: fixed;
  bottom: 100px;
  right: 20px;
  z-index: 1;
  img {
    display: block;
    width: 100%;
  }
}
.menu-list {
  float: right;
  max-height: 600px;
  overflow-y: scroll;
  padding: 8px;
  width: 60%;
  background-color: rgba(163, 121, 61, 0.8);
  .menu-item {
    overflow: hidden;
    padding: 4px 0;
    img {
      float: left;
      display: block;
      width: 24%;
    }
    .menu-text {
      float: right;
      width: 70%;
    }
  }
  .return {
    height: 50px;
    text-align: center;
    img {
      display: block;
      height: 100%;
      margin: auto;
    }
  }
}
</style>
